mutation UpdatePeopleIqPreference($input: PeopleIqPreferenceInput!) {
    peopleIqPreference(input: $input) {
        account {
            id
            name
        }
    }
}
